import { WarehouseDTO } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'

export const editItem = (userId: string, addressId: string, dto: WarehouseDTO) =>
  apiClient.put<WarehouseDTO>(endpoints.userAddress(userId, addressId), dto)
